import React from "react";
import { Alert } from 'reactstrap';

const Footer = props => (
    <footer>
        <h5 style={{margin:'20px auto 0', width:'180px'}}><a href="https://www.taydaelectronics.com" target="_blank" rel="noopener noreferrer" style={{color:"#212529"}}>Tayda Electronics&reg;</a></h5>
    </footer>
);

export default Footer;